import React, { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import AboutSectionStyle4 from '../Section/AboutSection/AboutSectionStyle4.jsx';
import BrandSection from '../Section/BrandSection';
import WorkingProcessSection from '../Section/WorkingProcessSection.jsx';
import TestimonialSliderStyle3 from '../Slider/TestimonialSliderStyle3.jsx';
import ContactSectionStyle2 from '../Section/ContactSection/ContactSectionStyle2.jsx';
import { pageTitle } from '../../helpers/PageTitle';


const brandData = [
  { imgUrl: '/images/brand/brand-1-1.png' },
  { imgUrl: '/images/brand/brand-1-2.png' },
  { imgUrl: '/images/brand/brand-1-3.png' },
  { imgUrl: '/images/brand/brand-1-4.png' },
  { imgUrl: '/images/brand/brand-1-5.png' },
  { imgUrl: '/images/brand/brand-1-6.png' },
  { imgUrl: '/images/brand/brand-1-7.png' },
  { imgUrl: '/images/brand/brand-1-8.png' },
  { imgUrl: '/images/brand/brand-1-9.png' },
  { imgUrl: '/images/brand/brand-1-10.png' },
  { imgUrl: '/images/brand/brand-1-11.png' },
  { imgUrl: '/images/brand/brand-1-12.png' },
];

const stepData = [
  {
    imgUrl: 'images/consultation.png',
    title: 'Consultation & Planning',
    desc: 'We discuss your ideas and requirements to create the perfect design plan tailored to your space, including cost estimates and timelines.',
    step: '01',
  },
  {
    imgUrl: 'images/designing.png',
    title: 'Design & Approval',
    desc: '3D sketches and prototypes are created to match your vision. Once you review and approve, production begins.',
    step: '02',
  },
  {
    imgUrl: 'images/craftsmanship.png',
    title: 'Craftsmanship & Production',
    desc: 'High-quality materials are used in every project. We follow strict quality control standards to ensure your satisfaction.',
    step: '03',
  },
  {
    imgUrl: 'images/installation.png',
    title: 'Delivery & Installation',
    desc: 'Once the project is completed, we ensure it is delivered on time and in perfect condition. We also provide installation services if needed.',
    step: '04',
  },
];

const testimonialData = [
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    subTitle:
      "The team did an outstanding job on our kitchen cabinets. The finishing and detailing were beyond our expectations. Highly professional and delivered exactly on time.",
    rating: '5',
    name: 'Michael Thompson',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    subTitle:
      "We hired them for custom wardrobes and interior doors, and the craftsmanship was exceptional. Very reliable and easy to work with throughout the project.",
    rating: '4.5',
    name: 'Sarah Williams',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    subTitle:
      "From design to installation, everything was handled perfectly. Our living room wall paneling looks amazing. I would definitely recommend their carpentry services.",
    rating: '4',
    name: 'David Anderson',
  },
];

export default function AboutPage() {
  pageTitle('About Us');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="About Us" bgUrl="/images/page_header_1.jpeg" />

      <Section
        pt="140"
        pb="140"
        ptLg="80"
        pbLg="80"
        className="position-relative"
      >
        <AboutSectionStyle4
          imgUrl="/images/about-img.webp"
          sectionTitleUp="About Us"
          sectionTitle='Built on <span className="text-accent">Craft. Driven </span> by Precision '
          sectionSubTitle="At Hybrid One Carpentry, we bring over 25 years of hands-on craftsmanship to residential and commercial projects across Houston. From custom cabinetry and millwork to complete interior wood solutions, every project is built with precision and built to last.<br/> We combine traditional woodworking skill with modern design to deliver clean finishes, durable results — on time and on budget."
          srcUrl="/contact"
          aboutList={['Craftsmanship', 'Integrity', 'Collaboration', 'Reliability', 'Excellence']}
        />
      </Section>

      {/* <Section pt="0" pb="80" ptLg="80">
        <ServiceSection
          data={serviceData}
          sectionTitleUp="Our Services"
          sectionTitle="Precision. Function. Beauty."
          sectionSubTitle="At HybridOne Carpentry, we provide a complete range of custom carpentry and millwork services designed to enhance the beauty, functionality, and value of residential and commercial spaces across Houston."
          sectionBtnText="Find More Services"
          sectionBtnUrl="/service"
          textVariant="text-white"
        />
      </Section> */}

      <Section pt="110" ptLg="80" pb="110" pbLg="80" className="bg-gray">
        <BrandSection data={brandData} />
      </Section>

      <Section pt='120' pb="120" ptLg="75">
        <WorkingProcessSection
          sectionTitleUp="Working Process"
          sectionTitle="Check How We Work in <br/>  Easy Steps"
          data={stepData}
        />
      </Section>

      <Section>
        <div className="cs_pb_131 cs_pt_131 bg-accent">
          <TestimonialSliderStyle3 data={testimonialData} />
        </div>
      </Section>

      <Section pt="80" ptLg="75" pb="85" pbLg="55">
        <ContactSectionStyle2
          sectionTitle="Let’s Build Your Vision"
          sectionTitleUp="Contact Hybrid One Carpentry"
          sectionSubTitle="Custom cabinetry, millwork, doors, and furniture tailored to your space. Serving Greater Houston with precision craftsmanship — request a free estimate today."
          featureList={[
            'Free site visit & estimate',
            'Licensed, insured workmanship',
            'Custom design options',
            'High-quality materials',
            'On-time project delivery',
          ]}
          contactInfo={[
            {
              imgUrl: '/images/icons/contact_icon_1.svg',
              titleUp: 'Have Any Question?',
              title: '+1 (281) 409 5882',
              textColor: 'text-primary',
            },
            {
              imgUrl: '/images/icons/contact_icon_2.svg',
              titleUp: 'Send Email',
              title: 'manager@hybridonecarpentry.com',
              textColor: 'text-primary',
            },
          ]}
        />
      </Section>
    </>
  );
}
